module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M28 16h-4c-2 0-2-2.2-2-2.2v-4c0-1.104-.894-1.8-2-1.8h-8c-1.106 0-2 .698-2 1.8v4c0 2-2 2.2-2 2.2H4s-2-.2-2 1.8V30c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V17.8c0-1.75-2-1.8-2-1.8zM16 28a6 6 0 1 1 0-12 6 6 0 0 1 0 12zM1.73 3.928C.756 4.45 0 5.824 0 6.93V10c0 1.106.894 2 2 2h2c1.106 0 2-.894 2-2V6c0-1.106.894-2 2-2h16c1.106 0 2 .894 2 2v4c0 1.106.894 2 2 2h2c1.106 0 2-.894 2-2V6.93c0-1.106-.756-2.48-1.73-3.002C27.572 2.486 22.042 0 16 0S4.428 2.486 1.73 3.928z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/call-4.js
// module id = 1042
// module chunks = 14